import type * as CSS from 'csstype'
import { system, Config } from '@styled-system/core'
import { ResponsiveValue } from '../utils/types'

export interface SvgProps {
  /**
   * The fill attribute has two different meanings. For shapes and text it's a presentation attribute that defines the color (or any SVG paint servers like gradients or patterns) used to paint the element; for animation it defines the final state of the animation.
   *
   * [MDN reference](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/fill)
   */
  fill?: ResponsiveValue<CSS.FillProperty>
}

const config: Config = {
  fill: {
    property: 'fill',
    scale: 'colors'
  }
}

export const svgProps = system(config)
